/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { TenantCourseStatistics } from './TenantCourseStatistics';
const TenantStatisticsParser = /* #__PURE__ */ parsers.object([
    [
        'studentAmounts',
        /* #__PURE__ */ codec.record(codecString, codecNumber),
        'student_amounts',
    ],
    [
        'submissionAmounts',
        /* #__PURE__ */ codec.record(codecString, codecNumber),
        'submission_amounts',
    ],
    ['amountSubmissionsLastWeek', codecNumber, 'amount_submissions_last_week'],
    ['courseAmounts', TenantCourseStatistics, 'course_amounts'],
]);
export class TenantStatistics extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TenantStatisticsParser.decode(input).map(res => new TenantStatistics(res));
    }
    static unsafeDecode(input) {
        return TenantStatistics.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantStatisticsParser.encode(data);
    }
    static schema() {
        return TenantStatisticsParser.schema();
    }
}
